import React, { createContext, useState, useContext, ReactNode } from "react";

type SegmentsContextType = {
  activeItemId: string | null;
  setActiveItemId: (id: string | null) => void;
};

const SegmentsContext = createContext<SegmentsContextType | undefined>(
  undefined
);

export const SegmentsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [activeItemId, setActiveItemId] = useState<string | null>(null);

  return (
    <SegmentsContext.Provider value={{ activeItemId, setActiveItemId }}>
      {children}
    </SegmentsContext.Provider>
  );
};

export const useSegmentsContext = () => {
  const context = useContext(SegmentsContext);
  if (context === undefined) {
    throw new Error(
      "useSegmentsContext must be used within a SegmentsProvider"
    );
  }
  return context;
};
